import React, { Component } from "react";
import { connect } from "react-redux";
import { sendSearch } from "../../redux/actions/apiAction";
import { Row, Col, Form, Button, Image } from "react-bootstrap";

import Geocode from "react-geocode";
import ZipCodeService from "../../actions/zipcode";
import WokkoCercaDeMi from "../../actions/wokkocercca";
import shop from '../../assets/images/shop.svg'
import dollar from '../../assets/images/dollar.svg'
import credit_card from '../../assets/images/credit-card.svg'
import search from '../../assets/images/search.svg'

Geocode.setApiKey('AIzaSyBdXowClhkgue9azazAkIqQ0XrjGs61lUo');
Geocode.setLanguage("es-419");
Geocode.setRegion("mx");
Geocode.enableDebug();

const TypeShop = {
  toPay: "toPay",
  getMoney: "getMoney",
  addMoney: "addMoney",
};


class FormSeach extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: "",
      address: "",
      typeShop: {
        toPay: false,
        getMoney: false,
        addMoney: false,
      },
    };

    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangeTypeShop = this.handleChangeTypeShop.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleChangeAddress(e) {
    this.setState({ address: e.target.value });
  }

  handleChangeTypeShop(typeShop, value) {
    this.setState({ typeShop: { ...this.state.typeShop, [typeShop]: value } });
  }

  setMessageError(message, statusLoading) {
    this.props.updateText(message);
    if (statusLoading !== undefined) {
      this.props.toggleLoading(statusLoading);
    }

    this.props.onSearchSubmit([]);
  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  async handleSearch(e) {
    e.preventDefault();
    const messageError =
      "¡Ups! No encontramos resultados, prueba con otra dirección.";

    if (this.state.address === "") {
      this.setMessageError("Debes agregar una dirección o un código postal.");
      return;
    }
    if (this.state.typeShop === "") {
      this.setMessageError("Selecciona un filtro para realizar la búsqueda.");
      return;
    }

    let search = await this.validaAddress();
    if (search) {
      this.props.toggleLoading(true);
      let res = await this.getGeocodeLatLng(search);
      if (!res) {
        this.setMessageError(messageError, false);
        return;
      }
      let commerces = await this.getCommerces(res.lat, res.lng);
      let brandAll = await this.getBrandAll();
      let shops = [];
      let filters = [];

      if (
        this.state.typeShop.toPay &&
        this.state.typeShop.getMoney &&
        this.state.typeShop.addMoney
      ) {
        shops = [...commerces];
      } else {

        let commercesBrandArray = [];
        commerces.map(commerce => {
          if(!commercesBrandArray.includes( commerce.brandToken )){
            commercesBrandArray.push(commerce.brandToken)
          }
        });

        let commercesBrandOperations = brandAll.filter(brand => commercesBrandArray.includes(brand.brand));
        
        if (this.state.typeShop.toPay)
          filters.push("PAGAR")
        
        if (this.state.typeShop.getMoney) 
          filters.push("RETIRAR")
          
        if (this.state.typeShop.addMoney)
          filters.push("FONDOS")

        let shopsFiltered = commerces.filter( commerce => {
          let brand = commercesBrandOperations.filter(brand => commerce.brandToken === brand.brand);
          return filters.some((filter) => brand[0] && brand[0].tokenOperations && brand[0].tokenOperations.indexOf(filter) >= 0)
        });

        shops = [...shopsFiltered];

      }

      if (shops.length === 0) {
        this.setMessageError(messageError);
      } else {
        this.props.onSearchSubmit(shops);
      }

      this.props.toggleLoading(false);
    } else {
      this.setMessageError(messageError, false);
    }
  }

  async getCommerces(lat, lng) {
    const getCommercers = new WokkoCercaDeMi({
      REACT_APP_UAT_CERCADEMI_ENDPOINT:
        process.env.REACT_APP_UAT_CERCADEMI_ENDPOINT,
    });

    return await getCommercers.fetchCommerces(lat, lng);
  }

  async getBrandAll() {
    const getBrandAll = new WokkoCercaDeMi({
      REACT_APP_UAT_CERCADEMI_ENDPOINT:
      process.env.REACT_APP_UAT_CERCADEMI_BRAND_ALL,
    });

    return await getBrandAll.fetchBrandAll();
  }

  async getSepomex(cp) {
    const zipCodeService = new ZipCodeService({
      ZIP_CODE_SERVICE_ENDPOINT:
        process.env.REACT_APP_ZIP_CODE_SERVICE_ENDPOINT,
      IDENTIFIER_GET_ZIP_CODE: process.env.REACT_APP_IDENTIFIER_GET_ZIP_CODE,
    });

    let resepomex = await zipCodeService.fetchZipCode(cp);
    if (resepomex.length !== 0) {
      return `${resepomex[0].asentamiento}, ${resepomex[0].codigoPostal} ${resepomex[0].estado}, ${resepomex[0].municipio}`;
    } else {
      return "";
    }
  }

  async validaAddress() {
    const isnumber = /^[0-9]+$/;
    if (this.state.address.match(isnumber) && this.state.address.length === 5) {
      const datasepomex = await this.getSepomex(this.state.address);
      return datasepomex;
    } else {
      return `${
        this.state.state !== "" && this.state.state !== "Estado"
          ? this.state.state + ","
          : ""
      } ${this.state.address}`;
    }
  }

  async getGeocodeLatLng(address) {
    const res = await Geocode.fromAddress(address).then(
      (response) => {
        return response.results[0].geometry.location;
      },
      (err) => {
        return "";
      }
    );
    return res;
  }

  setClassSelected = (typeShop) => {
    return this.state.typeShop[typeShop] ? "selected" : "";
  };

  render() {
    return (
      <React.Fragment>
        <Form onSubmit={this.handleSearch}>
          <Row className="container-form">
            <Col sm={12} md={4} className="text-left">
              <Form.Group controlId="search.address">
                <Form.Control
                  placeholder="Ingresa una dirección o código postal"
                  className="form-input"
                  maxLength={100}
                  onChange={this.handleChangeAddress}
                />
              </Form.Group>
            </Col>
            <Col sm={12} md={8} className="text-center container-buttons">
              <Button
                variant="button-round"
                className={`search-buttons ${this.setClassSelected(
                  TypeShop.toPay
                )}`}
                onClick={() =>
                  this.handleChangeTypeShop(
                    TypeShop.toPay,
                    !this.state.typeShop.toPay
                  )
                }
              >
                <Image
                  src={shop}
                  width="30"
                  height="20"
                  className={`icon-button-${this.setClassSelected(
                    TypeShop.toPay
                  )}`}
                />
                Pagar en Comercio
              </Button>
              <Button
                variant="button-round"
                className={`search-buttons ${this.setClassSelected(
                  TypeShop.getMoney
                )}`}
                onClick={() =>
                  this.handleChangeTypeShop(
                    TypeShop.getMoney,
                    !this.state.typeShop.getMoney
                  )
                }
              >
                <Image
                  src={dollar}
                  width="18"
                  height="18"
                  className={`icon-button-${this.setClassSelected(
                    TypeShop.getMoney
                  )}`}
                />
                Retirar Dinero
              </Button>
              <Button
                variant="button-round"
                className={`search-buttons ${this.setClassSelected(
                  TypeShop.addMoney
                )}`}
                onClick={() =>
                  this.handleChangeTypeShop(
                    TypeShop.addMoney,
                    !this.state.typeShop.addMoney
                  )
                }
              >
                <Image
                  src={credit_card}
                  width="30"
                  height="20"
                  className={`icon-button-${this.setClassSelected(
                    TypeShop.addMoney
                  )}`}
                />
                Agregar Dinero
              </Button>
              <Button
                variant="button-round"
                type="submit"
                className="button-search"
                disabled={
                  !(
                    this.state.address &&
                    (this.state.typeShop.toPay ||
                      this.state.typeShop.getMoney ||
                      this.state.typeShop.addMoney)
                  )
                }
              >
                <Image src={search} width="30" height="20" />
              </Button>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  commerces: state.apiState.commerces,
});
export default connect(mapStateToProps, { sendSearch })(FormSeach);
